import Benefits from "@/components/enfini/Benefits";
import Footer from "@/components/enfini/Footer";
import Header from "@/components/enfini/Header";
import HowItWorks from "@/components/enfini/HowItWorks";
import Platforms from "@/components/enfini/Platforms";
import RevenueCalculator from "@/components/enfini/RevenueCalculator";
import Services from "@/components/enfini/Services";
import Upsell from "@/components/enfini/Upsell";
import { useEffect } from "react";
import EnfiniShield from "../enfinity/our-solutions/enfinishield";

export default function Shield() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const benefits = [
    {
      icon: "ShieldPlus",
      asset: "Protect",
      title: "Instant CID Protection",
      description:
        "We detect and claim re-uploads to ensure your rights are enforced the moment your content is online.",
    },
    {
      icon: "Coins",
      asset: "Revenue",
      title: "Revenue Recovery",
      description:
        "EnfiniShield ensures ad revenue from reuploads is rightfully redirected to you. No takedowns required, only fair and transparent earnings.",
    },
    {
      icon: "ChartBarBig",
      asset: "Puzzle",
      title: "No extra work, no cost",
      description:
        "We take on all labor costs to demonstrate our confidence in the product and commitment to your success.",
    },
  ];

  return (
    <div className="space-y-20">
      <EnfiniShield />
    </div>
  );
}
